import { auth } from '@/lib/firebase/initialize';
import {
  reset as resetApp,
  setAppAccessToken,
  setFirebaseAccessToken,
} from '@/lib/redux/app.slice';
import { useAppDispatch } from '@/lib/redux/store';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useCallback, useState } from 'react';

const useAuth = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();

  const handleLoginWithEmail = async (email: string, password: string) => {
    setError(undefined);
    setIsLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      console.log('useAuth: handleLoginWithEmail', { error });
      setError('Invalid Username and Password');
    }
    setIsLoading(false);
  };

  const handleLogout = useCallback(async () => {
    await signOut(auth);
    dispatch(resetApp());
    dispatch(setFirebaseAccessToken(''));
    dispatch(setAppAccessToken(''));
  }, [dispatch]);

  return {
    handleLoginWithEmail,
    handleLogout,
    isLoading,
    error,
  };
};

export default useAuth;
